export const MAX_CHECKLIST_ITEMS = 80;
